/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AdminEmissionsRecordsStatsListProviderWithSourceParameterInner,
    AdminEmissionsRecordsStatsListProviderWithSourceParameterInnerFromJSON,
    AdminEmissionsRecordsStatsListProviderWithSourceParameterInnerToJSON,
} from '../models/AdminEmissionsRecordsStatsListProviderWithSourceParameterInner';
import {
    type BridgerSurveyStats,
    BridgerSurveyStatsFromJSON,
    BridgerSurveyStatsToJSON,
} from '../models/BridgerSurveyStats';
import {
    type EmissionDateCounts,
    EmissionDateCountsFromJSON,
    EmissionDateCountsToJSON,
} from '../models/EmissionDateCounts';
import {
    type EmissionRecordStatsResponse,
    EmissionRecordStatsResponseFromJSON,
    EmissionRecordStatsResponseToJSON,
} from '../models/EmissionRecordStatsResponse';
import {
    type EmissionRecordView,
    EmissionRecordViewFromJSON,
    EmissionRecordViewToJSON,
} from '../models/EmissionRecordView';
import {
    type PaginatedEmissionRecordViewList,
    PaginatedEmissionRecordViewListFromJSON,
    PaginatedEmissionRecordViewListToJSON,
} from '../models/PaginatedEmissionRecordViewList';
import {
    type PdfExportResponse,
    PdfExportResponseFromJSON,
    PdfExportResponseToJSON,
} from '../models/PdfExportResponse';
import {
    type ReportRespose,
    ReportResposeFromJSON,
    ReportResposeToJSON,
} from '../models/ReportRespose';

export interface EmissionRecordsBridgerStatsListRequest {
    assignedTo?: Array<number>;
    bridgerDetectionId?: string;
    bridgerEmissionLocationId?: string;
    bridgerEmitterHeightFtMax?: number;
    bridgerEmitterHeightFtMin?: number;
    bridgerEquipmentId?: string;
    bridgerEquipmentType?: string;
    bridgerLocation?: string;
    bridgerPersistence?: string;
    bridgerSiteName?: string;
    concentrationMax?: number | null;
    concentrationMin?: number | null;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dataPointCreatedAtAfter?: Date;
    dataPointCreatedAtBefore?: Date;
    dataSource?: Array<EmissionRecordsBridgerStatsListDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    distanceTo?: string;
    epaSepNotificationReason?: Array<EmissionRecordsBridgerStatsListEpaSepNotificationReasonEnum>;
    eventStatus?: Array<EmissionRecordsBridgerStatsListEventStatusEnum>;
    eventStatusWithParentStatus?: Array<EmissionRecordsBridgerStatsListEventStatusWithParentStatusEnum>;
    eventUpdatedAtAfter?: Date;
    eventUpdatedAtBefore?: Date;
    excludeEventStatus?: Array<EmissionRecordsBridgerStatsListExcludeEventStatusEnum>;
    ids?: Array<string>;
    isMainEvent?: boolean;
    locationPreset?: Array<number>;
    locationWithin?: string;
    maxDistance?: number;
    ordering?: string;
    plume?: boolean;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedEvent?: string;
    relatedSite?: string;
    relatedSiteName?: string;
    search?: string;
    secondaryDataSource?: Array<string>;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface EmissionRecordsEmissionCountsListRequest {
    assignedTo?: Array<number>;
    bridgerDetectionId?: string;
    bridgerEmissionLocationId?: string;
    bridgerEmitterHeightFtMax?: number;
    bridgerEmitterHeightFtMin?: number;
    bridgerEquipmentId?: string;
    bridgerEquipmentType?: string;
    bridgerLocation?: string;
    bridgerPersistence?: string;
    bridgerSiteName?: string;
    concentrationMax?: number | null;
    concentrationMin?: number | null;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dataPointCreatedAtAfter?: Date;
    dataPointCreatedAtBefore?: Date;
    dataSource?: Array<EmissionRecordsEmissionCountsListDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    distanceTo?: string;
    epaSepNotificationReason?: Array<EmissionRecordsEmissionCountsListEpaSepNotificationReasonEnum>;
    eventStatus?: Array<EmissionRecordsEmissionCountsListEventStatusEnum>;
    eventStatusWithParentStatus?: Array<EmissionRecordsEmissionCountsListEventStatusWithParentStatusEnum>;
    eventUpdatedAtAfter?: Date;
    eventUpdatedAtBefore?: Date;
    excludeEventStatus?: Array<EmissionRecordsEmissionCountsListExcludeEventStatusEnum>;
    ids?: Array<string>;
    isMainEvent?: boolean;
    locationPreset?: Array<number>;
    locationWithin?: string;
    maxDistance?: number;
    ordering?: string;
    plume?: boolean;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedEvent?: string;
    relatedSite?: string;
    relatedSiteName?: string;
    search?: string;
    secondaryDataSource?: Array<string>;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface EmissionRecordsEmissionRecordStatsRetrieveRequest {
    assignedTo?: Array<number>;
    bridgerDetectionId?: string;
    bridgerEmissionLocationId?: string;
    bridgerEmitterHeightFtMax?: number;
    bridgerEmitterHeightFtMin?: number;
    bridgerEquipmentId?: string;
    bridgerEquipmentType?: string;
    bridgerLocation?: string;
    bridgerPersistence?: string;
    bridgerSiteName?: string;
    concentrationMax?: number | null;
    concentrationMin?: number | null;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dataPointCreatedAtAfter?: Date;
    dataPointCreatedAtBefore?: Date;
    dataSource?: Array<EmissionRecordsEmissionRecordStatsRetrieveDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    distanceTo?: string;
    epaSepNotificationReason?: Array<EmissionRecordsEmissionRecordStatsRetrieveEpaSepNotificationReasonEnum>;
    eventStatus?: Array<EmissionRecordsEmissionRecordStatsRetrieveEventStatusEnum>;
    eventStatusWithParentStatus?: Array<EmissionRecordsEmissionRecordStatsRetrieveEventStatusWithParentStatusEnum>;
    eventUpdatedAtAfter?: Date;
    eventUpdatedAtBefore?: Date;
    excludeEventStatus?: Array<EmissionRecordsEmissionRecordStatsRetrieveExcludeEventStatusEnum>;
    ids?: Array<string>;
    isMainEvent?: boolean;
    locationPreset?: Array<number>;
    locationWithin?: string;
    maxDistance?: number;
    ordering?: string;
    plume?: boolean;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedEvent?: string;
    relatedSite?: string;
    relatedSiteName?: string;
    search?: string;
    secondaryDataSource?: Array<string>;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface EmissionRecordsGenerateCsvReportCreateRequest {
    assignedTo?: Array<number>;
    bridgerDetectionId?: string;
    bridgerEmissionLocationId?: string;
    bridgerEmitterHeightFtMax?: number;
    bridgerEmitterHeightFtMin?: number;
    bridgerEquipmentId?: string;
    bridgerEquipmentType?: string;
    bridgerLocation?: string;
    bridgerPersistence?: string;
    bridgerSiteName?: string;
    concentrationMax?: number | null;
    concentrationMin?: number | null;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dataPointCreatedAtAfter?: Date;
    dataPointCreatedAtBefore?: Date;
    dataSource?: Array<EmissionRecordsGenerateCsvReportCreateDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    distanceTo?: string;
    epaSepNotificationReason?: Array<EmissionRecordsGenerateCsvReportCreateEpaSepNotificationReasonEnum>;
    eventStatus?: Array<EmissionRecordsGenerateCsvReportCreateEventStatusEnum>;
    eventStatusWithParentStatus?: Array<EmissionRecordsGenerateCsvReportCreateEventStatusWithParentStatusEnum>;
    eventUpdatedAtAfter?: Date;
    eventUpdatedAtBefore?: Date;
    excludeEventStatus?: Array<EmissionRecordsGenerateCsvReportCreateExcludeEventStatusEnum>;
    ids?: Array<string>;
    isMainEvent?: boolean;
    locationPreset?: Array<number>;
    locationWithin?: string;
    maxDistance?: number;
    ordering?: string;
    plume?: boolean;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedEvent?: string;
    relatedSite?: string;
    relatedSiteName?: string;
    search?: string;
    secondaryDataSource?: Array<string>;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface EmissionRecordsGeneratePdfCreateRequest {
    id: string;
}

export interface EmissionRecordsGetNearbyEventsListRequest {
    id: string;
    assignedTo?: Array<number>;
    bridgerDetectionId?: string;
    bridgerEmissionLocationId?: string;
    bridgerEmitterHeightFtMax?: number;
    bridgerEmitterHeightFtMin?: number;
    bridgerEquipmentId?: string;
    bridgerEquipmentType?: string;
    bridgerLocation?: string;
    bridgerPersistence?: string;
    bridgerSiteName?: string;
    concentrationMax?: number | null;
    concentrationMin?: number | null;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dataPointCreatedAtAfter?: Date;
    dataPointCreatedAtBefore?: Date;
    dataSource?: Array<EmissionRecordsGetNearbyEventsListDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    distanceTo?: string;
    epaSepNotificationReason?: Array<EmissionRecordsGetNearbyEventsListEpaSepNotificationReasonEnum>;
    eventStatus?: Array<EmissionRecordsGetNearbyEventsListEventStatusEnum>;
    eventStatusWithParentStatus?: Array<EmissionRecordsGetNearbyEventsListEventStatusWithParentStatusEnum>;
    eventUpdatedAtAfter?: Date;
    eventUpdatedAtBefore?: Date;
    excludeEventStatus?: Array<EmissionRecordsGetNearbyEventsListExcludeEventStatusEnum>;
    ids?: Array<string>;
    isMainEvent?: boolean;
    locationPreset?: Array<number>;
    locationWithin?: string;
    maxDistance?: number;
    ordering?: string;
    plume?: boolean;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedEvent?: string;
    relatedSite?: string;
    relatedSiteName?: string;
    search?: string;
    secondaryDataSource?: Array<string>;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface EmissionRecordsListRequest {
    assignedTo?: Array<number>;
    bridgerDetectionId?: string;
    bridgerEmissionLocationId?: string;
    bridgerEmitterHeightFtMax?: number;
    bridgerEmitterHeightFtMin?: number;
    bridgerEquipmentId?: string;
    bridgerEquipmentType?: string;
    bridgerLocation?: string;
    bridgerPersistence?: string;
    bridgerSiteName?: string;
    concentrationMax?: number | null;
    concentrationMin?: number | null;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dataPointCreatedAtAfter?: Date;
    dataPointCreatedAtBefore?: Date;
    dataSource?: Array<EmissionRecordsListDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    distanceTo?: string;
    epaSepNotificationReason?: Array<EmissionRecordsListEpaSepNotificationReasonEnum>;
    eventStatus?: Array<EmissionRecordsListEventStatusEnum>;
    eventStatusWithParentStatus?: Array<EmissionRecordsListEventStatusWithParentStatusEnum>;
    eventUpdatedAtAfter?: Date;
    eventUpdatedAtBefore?: Date;
    excludeEventStatus?: Array<EmissionRecordsListExcludeEventStatusEnum>;
    ids?: Array<string>;
    isMainEvent?: boolean;
    locationPreset?: Array<number>;
    locationWithin?: string;
    maxDistance?: number;
    ordering?: string;
    page?: number;
    pageSize?: number;
    plume?: boolean;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedEvent?: string;
    relatedSite?: string;
    relatedSiteName?: string;
    search?: string;
    secondaryDataSource?: Array<string>;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface EmissionRecordsRetrieveRequest {
    id: string;
}

/**
 * 
 */
export class EmissionRecordsApi extends runtime.BaseAPI {

    /**
     * Creates request options for emissionRecordsBridgerStatsList without sending the request
     */
    async emissionRecordsBridgerStatsListRequestOpts(requestParameters: EmissionRecordsBridgerStatsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assigned_to'] = requestParameters['assignedTo'];
        }

        if (requestParameters['bridgerDetectionId'] != null) {
            queryParameters['bridger_detection_id'] = requestParameters['bridgerDetectionId'];
        }

        if (requestParameters['bridgerEmissionLocationId'] != null) {
            queryParameters['bridger_emission_location_id'] = requestParameters['bridgerEmissionLocationId'];
        }

        if (requestParameters['bridgerEmitterHeightFtMax'] != null) {
            queryParameters['bridger_emitter_height_ft_max'] = requestParameters['bridgerEmitterHeightFtMax'];
        }

        if (requestParameters['bridgerEmitterHeightFtMin'] != null) {
            queryParameters['bridger_emitter_height_ft_min'] = requestParameters['bridgerEmitterHeightFtMin'];
        }

        if (requestParameters['bridgerEquipmentId'] != null) {
            queryParameters['bridger_equipment_id'] = requestParameters['bridgerEquipmentId'];
        }

        if (requestParameters['bridgerEquipmentType'] != null) {
            queryParameters['bridger_equipment_type'] = requestParameters['bridgerEquipmentType'];
        }

        if (requestParameters['bridgerLocation'] != null) {
            queryParameters['bridger_location'] = requestParameters['bridgerLocation'];
        }

        if (requestParameters['bridgerPersistence'] != null) {
            queryParameters['bridger_persistence'] = requestParameters['bridgerPersistence'];
        }

        if (requestParameters['bridgerSiteName'] != null) {
            queryParameters['bridger_site_name'] = requestParameters['bridgerSiteName'];
        }

        if (requestParameters['concentrationMax'] != null) {
            queryParameters['concentration_max'] = requestParameters['concentrationMax'];
        }

        if (requestParameters['concentrationMin'] != null) {
            queryParameters['concentration_min'] = requestParameters['concentrationMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtAfter'] != null) {
            queryParameters['data_point_created_at_after'] = (requestParameters['dataPointCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtBefore'] != null) {
            queryParameters['data_point_created_at_before'] = (requestParameters['dataPointCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distanceTo'] != null) {
            queryParameters['distance_to'] = requestParameters['distanceTo'];
        }

        if (requestParameters['epaSepNotificationReason'] != null) {
            queryParameters['epa_sep_notification_reason'] = requestParameters['epaSepNotificationReason'];
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['eventStatusWithParentStatus'] != null) {
            queryParameters['event_status_with_parent_status'] = requestParameters['eventStatusWithParentStatus'];
        }

        if (requestParameters['eventUpdatedAtAfter'] != null) {
            queryParameters['event_updated_at_after'] = (requestParameters['eventUpdatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventUpdatedAtBefore'] != null) {
            queryParameters['event_updated_at_before'] = (requestParameters['eventUpdatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['isMainEvent'] != null) {
            queryParameters['is_main_event'] = requestParameters['isMainEvent'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['maxDistance'] != null) {
            queryParameters['max_distance'] = requestParameters['maxDistance'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['plume'] != null) {
            queryParameters['plume'] = requestParameters['plume'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedEvent'] != null) {
            queryParameters['related_event'] = requestParameters['relatedEvent'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['relatedSiteName'] != null) {
            queryParameters['related_site_name'] = requestParameters['relatedSiteName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['secondaryDataSource'] != null) {
            queryParameters['secondary_data_source'] = requestParameters['secondaryDataSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emission-records/bridger_stats/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Bridger specific stats on the platform.
     */
    async emissionRecordsBridgerStatsListRaw(requestParameters: EmissionRecordsBridgerStatsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BridgerSurveyStats>>> {
        const requestOptions = await this.emissionRecordsBridgerStatsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BridgerSurveyStatsFromJSON));
    }

    /**
     * Bridger specific stats on the platform.
     */
    async emissionRecordsBridgerStatsList(requestParameters: EmissionRecordsBridgerStatsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BridgerSurveyStats>> {
        const response = await this.emissionRecordsBridgerStatsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissionRecordsEmissionCountsList without sending the request
     */
    async emissionRecordsEmissionCountsListRequestOpts(requestParameters: EmissionRecordsEmissionCountsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assigned_to'] = requestParameters['assignedTo'];
        }

        if (requestParameters['bridgerDetectionId'] != null) {
            queryParameters['bridger_detection_id'] = requestParameters['bridgerDetectionId'];
        }

        if (requestParameters['bridgerEmissionLocationId'] != null) {
            queryParameters['bridger_emission_location_id'] = requestParameters['bridgerEmissionLocationId'];
        }

        if (requestParameters['bridgerEmitterHeightFtMax'] != null) {
            queryParameters['bridger_emitter_height_ft_max'] = requestParameters['bridgerEmitterHeightFtMax'];
        }

        if (requestParameters['bridgerEmitterHeightFtMin'] != null) {
            queryParameters['bridger_emitter_height_ft_min'] = requestParameters['bridgerEmitterHeightFtMin'];
        }

        if (requestParameters['bridgerEquipmentId'] != null) {
            queryParameters['bridger_equipment_id'] = requestParameters['bridgerEquipmentId'];
        }

        if (requestParameters['bridgerEquipmentType'] != null) {
            queryParameters['bridger_equipment_type'] = requestParameters['bridgerEquipmentType'];
        }

        if (requestParameters['bridgerLocation'] != null) {
            queryParameters['bridger_location'] = requestParameters['bridgerLocation'];
        }

        if (requestParameters['bridgerPersistence'] != null) {
            queryParameters['bridger_persistence'] = requestParameters['bridgerPersistence'];
        }

        if (requestParameters['bridgerSiteName'] != null) {
            queryParameters['bridger_site_name'] = requestParameters['bridgerSiteName'];
        }

        if (requestParameters['concentrationMax'] != null) {
            queryParameters['concentration_max'] = requestParameters['concentrationMax'];
        }

        if (requestParameters['concentrationMin'] != null) {
            queryParameters['concentration_min'] = requestParameters['concentrationMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtAfter'] != null) {
            queryParameters['data_point_created_at_after'] = (requestParameters['dataPointCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtBefore'] != null) {
            queryParameters['data_point_created_at_before'] = (requestParameters['dataPointCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distanceTo'] != null) {
            queryParameters['distance_to'] = requestParameters['distanceTo'];
        }

        if (requestParameters['epaSepNotificationReason'] != null) {
            queryParameters['epa_sep_notification_reason'] = requestParameters['epaSepNotificationReason'];
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['eventStatusWithParentStatus'] != null) {
            queryParameters['event_status_with_parent_status'] = requestParameters['eventStatusWithParentStatus'];
        }

        if (requestParameters['eventUpdatedAtAfter'] != null) {
            queryParameters['event_updated_at_after'] = (requestParameters['eventUpdatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventUpdatedAtBefore'] != null) {
            queryParameters['event_updated_at_before'] = (requestParameters['eventUpdatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['isMainEvent'] != null) {
            queryParameters['is_main_event'] = requestParameters['isMainEvent'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['maxDistance'] != null) {
            queryParameters['max_distance'] = requestParameters['maxDistance'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['plume'] != null) {
            queryParameters['plume'] = requestParameters['plume'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedEvent'] != null) {
            queryParameters['related_event'] = requestParameters['relatedEvent'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['relatedSiteName'] != null) {
            queryParameters['related_site_name'] = requestParameters['relatedSiteName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['secondaryDataSource'] != null) {
            queryParameters['secondary_data_source'] = requestParameters['secondaryDataSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emission-records/emission_counts/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a list of datetimes where emissions are present.
     */
    async emissionRecordsEmissionCountsListRaw(requestParameters: EmissionRecordsEmissionCountsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EmissionDateCounts>>> {
        const requestOptions = await this.emissionRecordsEmissionCountsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EmissionDateCountsFromJSON));
    }

    /**
     * Returns a list of datetimes where emissions are present.
     */
    async emissionRecordsEmissionCountsList(requestParameters: EmissionRecordsEmissionCountsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EmissionDateCounts>> {
        const response = await this.emissionRecordsEmissionCountsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissionRecordsEmissionRecordStatsRetrieve without sending the request
     */
    async emissionRecordsEmissionRecordStatsRetrieveRequestOpts(requestParameters: EmissionRecordsEmissionRecordStatsRetrieveRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assigned_to'] = requestParameters['assignedTo'];
        }

        if (requestParameters['bridgerDetectionId'] != null) {
            queryParameters['bridger_detection_id'] = requestParameters['bridgerDetectionId'];
        }

        if (requestParameters['bridgerEmissionLocationId'] != null) {
            queryParameters['bridger_emission_location_id'] = requestParameters['bridgerEmissionLocationId'];
        }

        if (requestParameters['bridgerEmitterHeightFtMax'] != null) {
            queryParameters['bridger_emitter_height_ft_max'] = requestParameters['bridgerEmitterHeightFtMax'];
        }

        if (requestParameters['bridgerEmitterHeightFtMin'] != null) {
            queryParameters['bridger_emitter_height_ft_min'] = requestParameters['bridgerEmitterHeightFtMin'];
        }

        if (requestParameters['bridgerEquipmentId'] != null) {
            queryParameters['bridger_equipment_id'] = requestParameters['bridgerEquipmentId'];
        }

        if (requestParameters['bridgerEquipmentType'] != null) {
            queryParameters['bridger_equipment_type'] = requestParameters['bridgerEquipmentType'];
        }

        if (requestParameters['bridgerLocation'] != null) {
            queryParameters['bridger_location'] = requestParameters['bridgerLocation'];
        }

        if (requestParameters['bridgerPersistence'] != null) {
            queryParameters['bridger_persistence'] = requestParameters['bridgerPersistence'];
        }

        if (requestParameters['bridgerSiteName'] != null) {
            queryParameters['bridger_site_name'] = requestParameters['bridgerSiteName'];
        }

        if (requestParameters['concentrationMax'] != null) {
            queryParameters['concentration_max'] = requestParameters['concentrationMax'];
        }

        if (requestParameters['concentrationMin'] != null) {
            queryParameters['concentration_min'] = requestParameters['concentrationMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtAfter'] != null) {
            queryParameters['data_point_created_at_after'] = (requestParameters['dataPointCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtBefore'] != null) {
            queryParameters['data_point_created_at_before'] = (requestParameters['dataPointCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distanceTo'] != null) {
            queryParameters['distance_to'] = requestParameters['distanceTo'];
        }

        if (requestParameters['epaSepNotificationReason'] != null) {
            queryParameters['epa_sep_notification_reason'] = requestParameters['epaSepNotificationReason'];
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['eventStatusWithParentStatus'] != null) {
            queryParameters['event_status_with_parent_status'] = requestParameters['eventStatusWithParentStatus'];
        }

        if (requestParameters['eventUpdatedAtAfter'] != null) {
            queryParameters['event_updated_at_after'] = (requestParameters['eventUpdatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventUpdatedAtBefore'] != null) {
            queryParameters['event_updated_at_before'] = (requestParameters['eventUpdatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['isMainEvent'] != null) {
            queryParameters['is_main_event'] = requestParameters['isMainEvent'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['maxDistance'] != null) {
            queryParameters['max_distance'] = requestParameters['maxDistance'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['plume'] != null) {
            queryParameters['plume'] = requestParameters['plume'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedEvent'] != null) {
            queryParameters['related_event'] = requestParameters['relatedEvent'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['relatedSiteName'] != null) {
            queryParameters['related_site_name'] = requestParameters['relatedSiteName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['secondaryDataSource'] != null) {
            queryParameters['secondary_data_source'] = requestParameters['secondaryDataSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emission-records/emission_record_stats/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns statistics to be displayed in a dashboard style.
     */
    async emissionRecordsEmissionRecordStatsRetrieveRaw(requestParameters: EmissionRecordsEmissionRecordStatsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmissionRecordStatsResponse>> {
        const requestOptions = await this.emissionRecordsEmissionRecordStatsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmissionRecordStatsResponseFromJSON(jsonValue));
    }

    /**
     * Returns statistics to be displayed in a dashboard style.
     */
    async emissionRecordsEmissionRecordStatsRetrieve(requestParameters: EmissionRecordsEmissionRecordStatsRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmissionRecordStatsResponse> {
        const response = await this.emissionRecordsEmissionRecordStatsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissionRecordsGenerateCsvReportCreate without sending the request
     */
    async emissionRecordsGenerateCsvReportCreateRequestOpts(requestParameters: EmissionRecordsGenerateCsvReportCreateRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assigned_to'] = requestParameters['assignedTo'];
        }

        if (requestParameters['bridgerDetectionId'] != null) {
            queryParameters['bridger_detection_id'] = requestParameters['bridgerDetectionId'];
        }

        if (requestParameters['bridgerEmissionLocationId'] != null) {
            queryParameters['bridger_emission_location_id'] = requestParameters['bridgerEmissionLocationId'];
        }

        if (requestParameters['bridgerEmitterHeightFtMax'] != null) {
            queryParameters['bridger_emitter_height_ft_max'] = requestParameters['bridgerEmitterHeightFtMax'];
        }

        if (requestParameters['bridgerEmitterHeightFtMin'] != null) {
            queryParameters['bridger_emitter_height_ft_min'] = requestParameters['bridgerEmitterHeightFtMin'];
        }

        if (requestParameters['bridgerEquipmentId'] != null) {
            queryParameters['bridger_equipment_id'] = requestParameters['bridgerEquipmentId'];
        }

        if (requestParameters['bridgerEquipmentType'] != null) {
            queryParameters['bridger_equipment_type'] = requestParameters['bridgerEquipmentType'];
        }

        if (requestParameters['bridgerLocation'] != null) {
            queryParameters['bridger_location'] = requestParameters['bridgerLocation'];
        }

        if (requestParameters['bridgerPersistence'] != null) {
            queryParameters['bridger_persistence'] = requestParameters['bridgerPersistence'];
        }

        if (requestParameters['bridgerSiteName'] != null) {
            queryParameters['bridger_site_name'] = requestParameters['bridgerSiteName'];
        }

        if (requestParameters['concentrationMax'] != null) {
            queryParameters['concentration_max'] = requestParameters['concentrationMax'];
        }

        if (requestParameters['concentrationMin'] != null) {
            queryParameters['concentration_min'] = requestParameters['concentrationMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtAfter'] != null) {
            queryParameters['data_point_created_at_after'] = (requestParameters['dataPointCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtBefore'] != null) {
            queryParameters['data_point_created_at_before'] = (requestParameters['dataPointCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distanceTo'] != null) {
            queryParameters['distance_to'] = requestParameters['distanceTo'];
        }

        if (requestParameters['epaSepNotificationReason'] != null) {
            queryParameters['epa_sep_notification_reason'] = requestParameters['epaSepNotificationReason'];
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['eventStatusWithParentStatus'] != null) {
            queryParameters['event_status_with_parent_status'] = requestParameters['eventStatusWithParentStatus'];
        }

        if (requestParameters['eventUpdatedAtAfter'] != null) {
            queryParameters['event_updated_at_after'] = (requestParameters['eventUpdatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventUpdatedAtBefore'] != null) {
            queryParameters['event_updated_at_before'] = (requestParameters['eventUpdatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['isMainEvent'] != null) {
            queryParameters['is_main_event'] = requestParameters['isMainEvent'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['maxDistance'] != null) {
            queryParameters['max_distance'] = requestParameters['maxDistance'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['plume'] != null) {
            queryParameters['plume'] = requestParameters['plume'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedEvent'] != null) {
            queryParameters['related_event'] = requestParameters['relatedEvent'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['relatedSiteName'] != null) {
            queryParameters['related_site_name'] = requestParameters['relatedSiteName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['secondaryDataSource'] != null) {
            queryParameters['secondary_data_source'] = requestParameters['secondaryDataSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emission-records/generate_csv_report/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * If the user has permissions, triggers report generation.
     */
    async emissionRecordsGenerateCsvReportCreateRaw(requestParameters: EmissionRecordsGenerateCsvReportCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportRespose>> {
        const requestOptions = await this.emissionRecordsGenerateCsvReportCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportResposeFromJSON(jsonValue));
    }

    /**
     * If the user has permissions, triggers report generation.
     */
    async emissionRecordsGenerateCsvReportCreate(requestParameters: EmissionRecordsGenerateCsvReportCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportRespose> {
        const response = await this.emissionRecordsGenerateCsvReportCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissionRecordsGeneratePdfCreate without sending the request
     */
    async emissionRecordsGeneratePdfCreateRequestOpts(requestParameters: EmissionRecordsGeneratePdfCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling emissionRecordsGeneratePdfCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emission-records/{id}/generate_pdf/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Triggers the creation of a PDF export for the given emission. Requires the \'enable_download_emission_pdf\' flag to be active for the user.
     */
    async emissionRecordsGeneratePdfCreateRaw(requestParameters: EmissionRecordsGeneratePdfCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PdfExportResponse>> {
        const requestOptions = await this.emissionRecordsGeneratePdfCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PdfExportResponseFromJSON(jsonValue));
    }

    /**
     * Triggers the creation of a PDF export for the given emission. Requires the \'enable_download_emission_pdf\' flag to be active for the user.
     */
    async emissionRecordsGeneratePdfCreate(requestParameters: EmissionRecordsGeneratePdfCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PdfExportResponse> {
        const response = await this.emissionRecordsGeneratePdfCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissionRecordsGetNearbyEventsList without sending the request
     */
    async emissionRecordsGetNearbyEventsListRequestOpts(requestParameters: EmissionRecordsGetNearbyEventsListRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling emissionRecordsGetNearbyEventsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assigned_to'] = requestParameters['assignedTo'];
        }

        if (requestParameters['bridgerDetectionId'] != null) {
            queryParameters['bridger_detection_id'] = requestParameters['bridgerDetectionId'];
        }

        if (requestParameters['bridgerEmissionLocationId'] != null) {
            queryParameters['bridger_emission_location_id'] = requestParameters['bridgerEmissionLocationId'];
        }

        if (requestParameters['bridgerEmitterHeightFtMax'] != null) {
            queryParameters['bridger_emitter_height_ft_max'] = requestParameters['bridgerEmitterHeightFtMax'];
        }

        if (requestParameters['bridgerEmitterHeightFtMin'] != null) {
            queryParameters['bridger_emitter_height_ft_min'] = requestParameters['bridgerEmitterHeightFtMin'];
        }

        if (requestParameters['bridgerEquipmentId'] != null) {
            queryParameters['bridger_equipment_id'] = requestParameters['bridgerEquipmentId'];
        }

        if (requestParameters['bridgerEquipmentType'] != null) {
            queryParameters['bridger_equipment_type'] = requestParameters['bridgerEquipmentType'];
        }

        if (requestParameters['bridgerLocation'] != null) {
            queryParameters['bridger_location'] = requestParameters['bridgerLocation'];
        }

        if (requestParameters['bridgerPersistence'] != null) {
            queryParameters['bridger_persistence'] = requestParameters['bridgerPersistence'];
        }

        if (requestParameters['bridgerSiteName'] != null) {
            queryParameters['bridger_site_name'] = requestParameters['bridgerSiteName'];
        }

        if (requestParameters['concentrationMax'] != null) {
            queryParameters['concentration_max'] = requestParameters['concentrationMax'];
        }

        if (requestParameters['concentrationMin'] != null) {
            queryParameters['concentration_min'] = requestParameters['concentrationMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtAfter'] != null) {
            queryParameters['data_point_created_at_after'] = (requestParameters['dataPointCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtBefore'] != null) {
            queryParameters['data_point_created_at_before'] = (requestParameters['dataPointCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distanceTo'] != null) {
            queryParameters['distance_to'] = requestParameters['distanceTo'];
        }

        if (requestParameters['epaSepNotificationReason'] != null) {
            queryParameters['epa_sep_notification_reason'] = requestParameters['epaSepNotificationReason'];
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['eventStatusWithParentStatus'] != null) {
            queryParameters['event_status_with_parent_status'] = requestParameters['eventStatusWithParentStatus'];
        }

        if (requestParameters['eventUpdatedAtAfter'] != null) {
            queryParameters['event_updated_at_after'] = (requestParameters['eventUpdatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventUpdatedAtBefore'] != null) {
            queryParameters['event_updated_at_before'] = (requestParameters['eventUpdatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['isMainEvent'] != null) {
            queryParameters['is_main_event'] = requestParameters['isMainEvent'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['maxDistance'] != null) {
            queryParameters['max_distance'] = requestParameters['maxDistance'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['plume'] != null) {
            queryParameters['plume'] = requestParameters['plume'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedEvent'] != null) {
            queryParameters['related_event'] = requestParameters['relatedEvent'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['relatedSiteName'] != null) {
            queryParameters['related_site_name'] = requestParameters['relatedSiteName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['secondaryDataSource'] != null) {
            queryParameters['secondary_data_source'] = requestParameters['secondaryDataSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emission-records/{id}/get_nearby_events/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieves a list of similar emissions that are already linked to an event.  TODO: convert this into a custom filter instead of a custom action.
     */
    async emissionRecordsGetNearbyEventsListRaw(requestParameters: EmissionRecordsGetNearbyEventsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EmissionRecordView>>> {
        const requestOptions = await this.emissionRecordsGetNearbyEventsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EmissionRecordViewFromJSON));
    }

    /**
     * Retrieves a list of similar emissions that are already linked to an event.  TODO: convert this into a custom filter instead of a custom action.
     */
    async emissionRecordsGetNearbyEventsList(requestParameters: EmissionRecordsGetNearbyEventsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EmissionRecordView>> {
        const response = await this.emissionRecordsGetNearbyEventsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissionRecordsList without sending the request
     */
    async emissionRecordsListRequestOpts(requestParameters: EmissionRecordsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assigned_to'] = requestParameters['assignedTo'];
        }

        if (requestParameters['bridgerDetectionId'] != null) {
            queryParameters['bridger_detection_id'] = requestParameters['bridgerDetectionId'];
        }

        if (requestParameters['bridgerEmissionLocationId'] != null) {
            queryParameters['bridger_emission_location_id'] = requestParameters['bridgerEmissionLocationId'];
        }

        if (requestParameters['bridgerEmitterHeightFtMax'] != null) {
            queryParameters['bridger_emitter_height_ft_max'] = requestParameters['bridgerEmitterHeightFtMax'];
        }

        if (requestParameters['bridgerEmitterHeightFtMin'] != null) {
            queryParameters['bridger_emitter_height_ft_min'] = requestParameters['bridgerEmitterHeightFtMin'];
        }

        if (requestParameters['bridgerEquipmentId'] != null) {
            queryParameters['bridger_equipment_id'] = requestParameters['bridgerEquipmentId'];
        }

        if (requestParameters['bridgerEquipmentType'] != null) {
            queryParameters['bridger_equipment_type'] = requestParameters['bridgerEquipmentType'];
        }

        if (requestParameters['bridgerLocation'] != null) {
            queryParameters['bridger_location'] = requestParameters['bridgerLocation'];
        }

        if (requestParameters['bridgerPersistence'] != null) {
            queryParameters['bridger_persistence'] = requestParameters['bridgerPersistence'];
        }

        if (requestParameters['bridgerSiteName'] != null) {
            queryParameters['bridger_site_name'] = requestParameters['bridgerSiteName'];
        }

        if (requestParameters['concentrationMax'] != null) {
            queryParameters['concentration_max'] = requestParameters['concentrationMax'];
        }

        if (requestParameters['concentrationMin'] != null) {
            queryParameters['concentration_min'] = requestParameters['concentrationMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtAfter'] != null) {
            queryParameters['data_point_created_at_after'] = (requestParameters['dataPointCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtBefore'] != null) {
            queryParameters['data_point_created_at_before'] = (requestParameters['dataPointCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distanceTo'] != null) {
            queryParameters['distance_to'] = requestParameters['distanceTo'];
        }

        if (requestParameters['epaSepNotificationReason'] != null) {
            queryParameters['epa_sep_notification_reason'] = requestParameters['epaSepNotificationReason'];
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['eventStatusWithParentStatus'] != null) {
            queryParameters['event_status_with_parent_status'] = requestParameters['eventStatusWithParentStatus'];
        }

        if (requestParameters['eventUpdatedAtAfter'] != null) {
            queryParameters['event_updated_at_after'] = (requestParameters['eventUpdatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventUpdatedAtBefore'] != null) {
            queryParameters['event_updated_at_before'] = (requestParameters['eventUpdatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['isMainEvent'] != null) {
            queryParameters['is_main_event'] = requestParameters['isMainEvent'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['maxDistance'] != null) {
            queryParameters['max_distance'] = requestParameters['maxDistance'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['plume'] != null) {
            queryParameters['plume'] = requestParameters['plume'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedEvent'] != null) {
            queryParameters['related_event'] = requestParameters['relatedEvent'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['relatedSiteName'] != null) {
            queryParameters['related_site_name'] = requestParameters['relatedSiteName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['secondaryDataSource'] != null) {
            queryParameters['secondary_data_source'] = requestParameters['secondaryDataSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emission-records/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve emission information
     */
    async emissionRecordsListRaw(requestParameters: EmissionRecordsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedEmissionRecordViewList>> {
        const requestOptions = await this.emissionRecordsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedEmissionRecordViewListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve emission information
     */
    async emissionRecordsList(requestParameters: EmissionRecordsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedEmissionRecordViewList> {
        const response = await this.emissionRecordsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissionRecordsRetrieve without sending the request
     */
    async emissionRecordsRetrieveRequestOpts(requestParameters: EmissionRecordsRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling emissionRecordsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emission-records/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve emission information
     */
    async emissionRecordsRetrieveRaw(requestParameters: EmissionRecordsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmissionRecordView>> {
        const requestOptions = await this.emissionRecordsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmissionRecordViewFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve emission information
     */
    async emissionRecordsRetrieve(requestParameters: EmissionRecordsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmissionRecordView> {
        const response = await this.emissionRecordsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const EmissionRecordsBridgerStatsListDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type EmissionRecordsBridgerStatsListDataSourceEnum = typeof EmissionRecordsBridgerStatsListDataSourceEnum[keyof typeof EmissionRecordsBridgerStatsListDataSourceEnum];
/**
 * @export
 */
export const EmissionRecordsBridgerStatsListEpaSepNotificationReasonEnum = {
    EpaNotification: 'EPA_NOTIFICATION',
    MatchedInfrastructure: 'MATCHED_INFRASTRUCTURE',
    UserCreated: 'USER_CREATED'
} as const;
export type EmissionRecordsBridgerStatsListEpaSepNotificationReasonEnum = typeof EmissionRecordsBridgerStatsListEpaSepNotificationReasonEnum[keyof typeof EmissionRecordsBridgerStatsListEpaSepNotificationReasonEnum];
/**
 * @export
 */
export const EmissionRecordsBridgerStatsListEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsBridgerStatsListEventStatusEnum = typeof EmissionRecordsBridgerStatsListEventStatusEnum[keyof typeof EmissionRecordsBridgerStatsListEventStatusEnum];
/**
 * @export
 */
export const EmissionRecordsBridgerStatsListEventStatusWithParentStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsBridgerStatsListEventStatusWithParentStatusEnum = typeof EmissionRecordsBridgerStatsListEventStatusWithParentStatusEnum[keyof typeof EmissionRecordsBridgerStatsListEventStatusWithParentStatusEnum];
/**
 * @export
 */
export const EmissionRecordsBridgerStatsListExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsBridgerStatsListExcludeEventStatusEnum = typeof EmissionRecordsBridgerStatsListExcludeEventStatusEnum[keyof typeof EmissionRecordsBridgerStatsListExcludeEventStatusEnum];
/**
 * @export
 */
export const EmissionRecordsEmissionCountsListDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type EmissionRecordsEmissionCountsListDataSourceEnum = typeof EmissionRecordsEmissionCountsListDataSourceEnum[keyof typeof EmissionRecordsEmissionCountsListDataSourceEnum];
/**
 * @export
 */
export const EmissionRecordsEmissionCountsListEpaSepNotificationReasonEnum = {
    EpaNotification: 'EPA_NOTIFICATION',
    MatchedInfrastructure: 'MATCHED_INFRASTRUCTURE',
    UserCreated: 'USER_CREATED'
} as const;
export type EmissionRecordsEmissionCountsListEpaSepNotificationReasonEnum = typeof EmissionRecordsEmissionCountsListEpaSepNotificationReasonEnum[keyof typeof EmissionRecordsEmissionCountsListEpaSepNotificationReasonEnum];
/**
 * @export
 */
export const EmissionRecordsEmissionCountsListEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsEmissionCountsListEventStatusEnum = typeof EmissionRecordsEmissionCountsListEventStatusEnum[keyof typeof EmissionRecordsEmissionCountsListEventStatusEnum];
/**
 * @export
 */
export const EmissionRecordsEmissionCountsListEventStatusWithParentStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsEmissionCountsListEventStatusWithParentStatusEnum = typeof EmissionRecordsEmissionCountsListEventStatusWithParentStatusEnum[keyof typeof EmissionRecordsEmissionCountsListEventStatusWithParentStatusEnum];
/**
 * @export
 */
export const EmissionRecordsEmissionCountsListExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsEmissionCountsListExcludeEventStatusEnum = typeof EmissionRecordsEmissionCountsListExcludeEventStatusEnum[keyof typeof EmissionRecordsEmissionCountsListExcludeEventStatusEnum];
/**
 * @export
 */
export const EmissionRecordsEmissionRecordStatsRetrieveDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type EmissionRecordsEmissionRecordStatsRetrieveDataSourceEnum = typeof EmissionRecordsEmissionRecordStatsRetrieveDataSourceEnum[keyof typeof EmissionRecordsEmissionRecordStatsRetrieveDataSourceEnum];
/**
 * @export
 */
export const EmissionRecordsEmissionRecordStatsRetrieveEpaSepNotificationReasonEnum = {
    EpaNotification: 'EPA_NOTIFICATION',
    MatchedInfrastructure: 'MATCHED_INFRASTRUCTURE',
    UserCreated: 'USER_CREATED'
} as const;
export type EmissionRecordsEmissionRecordStatsRetrieveEpaSepNotificationReasonEnum = typeof EmissionRecordsEmissionRecordStatsRetrieveEpaSepNotificationReasonEnum[keyof typeof EmissionRecordsEmissionRecordStatsRetrieveEpaSepNotificationReasonEnum];
/**
 * @export
 */
export const EmissionRecordsEmissionRecordStatsRetrieveEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsEmissionRecordStatsRetrieveEventStatusEnum = typeof EmissionRecordsEmissionRecordStatsRetrieveEventStatusEnum[keyof typeof EmissionRecordsEmissionRecordStatsRetrieveEventStatusEnum];
/**
 * @export
 */
export const EmissionRecordsEmissionRecordStatsRetrieveEventStatusWithParentStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsEmissionRecordStatsRetrieveEventStatusWithParentStatusEnum = typeof EmissionRecordsEmissionRecordStatsRetrieveEventStatusWithParentStatusEnum[keyof typeof EmissionRecordsEmissionRecordStatsRetrieveEventStatusWithParentStatusEnum];
/**
 * @export
 */
export const EmissionRecordsEmissionRecordStatsRetrieveExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsEmissionRecordStatsRetrieveExcludeEventStatusEnum = typeof EmissionRecordsEmissionRecordStatsRetrieveExcludeEventStatusEnum[keyof typeof EmissionRecordsEmissionRecordStatsRetrieveExcludeEventStatusEnum];
/**
 * @export
 */
export const EmissionRecordsGenerateCsvReportCreateDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type EmissionRecordsGenerateCsvReportCreateDataSourceEnum = typeof EmissionRecordsGenerateCsvReportCreateDataSourceEnum[keyof typeof EmissionRecordsGenerateCsvReportCreateDataSourceEnum];
/**
 * @export
 */
export const EmissionRecordsGenerateCsvReportCreateEpaSepNotificationReasonEnum = {
    EpaNotification: 'EPA_NOTIFICATION',
    MatchedInfrastructure: 'MATCHED_INFRASTRUCTURE',
    UserCreated: 'USER_CREATED'
} as const;
export type EmissionRecordsGenerateCsvReportCreateEpaSepNotificationReasonEnum = typeof EmissionRecordsGenerateCsvReportCreateEpaSepNotificationReasonEnum[keyof typeof EmissionRecordsGenerateCsvReportCreateEpaSepNotificationReasonEnum];
/**
 * @export
 */
export const EmissionRecordsGenerateCsvReportCreateEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsGenerateCsvReportCreateEventStatusEnum = typeof EmissionRecordsGenerateCsvReportCreateEventStatusEnum[keyof typeof EmissionRecordsGenerateCsvReportCreateEventStatusEnum];
/**
 * @export
 */
export const EmissionRecordsGenerateCsvReportCreateEventStatusWithParentStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsGenerateCsvReportCreateEventStatusWithParentStatusEnum = typeof EmissionRecordsGenerateCsvReportCreateEventStatusWithParentStatusEnum[keyof typeof EmissionRecordsGenerateCsvReportCreateEventStatusWithParentStatusEnum];
/**
 * @export
 */
export const EmissionRecordsGenerateCsvReportCreateExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsGenerateCsvReportCreateExcludeEventStatusEnum = typeof EmissionRecordsGenerateCsvReportCreateExcludeEventStatusEnum[keyof typeof EmissionRecordsGenerateCsvReportCreateExcludeEventStatusEnum];
/**
 * @export
 */
export const EmissionRecordsGetNearbyEventsListDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type EmissionRecordsGetNearbyEventsListDataSourceEnum = typeof EmissionRecordsGetNearbyEventsListDataSourceEnum[keyof typeof EmissionRecordsGetNearbyEventsListDataSourceEnum];
/**
 * @export
 */
export const EmissionRecordsGetNearbyEventsListEpaSepNotificationReasonEnum = {
    EpaNotification: 'EPA_NOTIFICATION',
    MatchedInfrastructure: 'MATCHED_INFRASTRUCTURE',
    UserCreated: 'USER_CREATED'
} as const;
export type EmissionRecordsGetNearbyEventsListEpaSepNotificationReasonEnum = typeof EmissionRecordsGetNearbyEventsListEpaSepNotificationReasonEnum[keyof typeof EmissionRecordsGetNearbyEventsListEpaSepNotificationReasonEnum];
/**
 * @export
 */
export const EmissionRecordsGetNearbyEventsListEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsGetNearbyEventsListEventStatusEnum = typeof EmissionRecordsGetNearbyEventsListEventStatusEnum[keyof typeof EmissionRecordsGetNearbyEventsListEventStatusEnum];
/**
 * @export
 */
export const EmissionRecordsGetNearbyEventsListEventStatusWithParentStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsGetNearbyEventsListEventStatusWithParentStatusEnum = typeof EmissionRecordsGetNearbyEventsListEventStatusWithParentStatusEnum[keyof typeof EmissionRecordsGetNearbyEventsListEventStatusWithParentStatusEnum];
/**
 * @export
 */
export const EmissionRecordsGetNearbyEventsListExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsGetNearbyEventsListExcludeEventStatusEnum = typeof EmissionRecordsGetNearbyEventsListExcludeEventStatusEnum[keyof typeof EmissionRecordsGetNearbyEventsListExcludeEventStatusEnum];
/**
 * @export
 */
export const EmissionRecordsListDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type EmissionRecordsListDataSourceEnum = typeof EmissionRecordsListDataSourceEnum[keyof typeof EmissionRecordsListDataSourceEnum];
/**
 * @export
 */
export const EmissionRecordsListEpaSepNotificationReasonEnum = {
    EpaNotification: 'EPA_NOTIFICATION',
    MatchedInfrastructure: 'MATCHED_INFRASTRUCTURE',
    UserCreated: 'USER_CREATED'
} as const;
export type EmissionRecordsListEpaSepNotificationReasonEnum = typeof EmissionRecordsListEpaSepNotificationReasonEnum[keyof typeof EmissionRecordsListEpaSepNotificationReasonEnum];
/**
 * @export
 */
export const EmissionRecordsListEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsListEventStatusEnum = typeof EmissionRecordsListEventStatusEnum[keyof typeof EmissionRecordsListEventStatusEnum];
/**
 * @export
 */
export const EmissionRecordsListEventStatusWithParentStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsListEventStatusWithParentStatusEnum = typeof EmissionRecordsListEventStatusWithParentStatusEnum[keyof typeof EmissionRecordsListEventStatusWithParentStatusEnum];
/**
 * @export
 */
export const EmissionRecordsListExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissionRecordsListExcludeEventStatusEnum = typeof EmissionRecordsListExcludeEventStatusEnum[keyof typeof EmissionRecordsListExcludeEventStatusEnum];
